var formsHelper = require('../../utils/forms_helper');

jQuery(function ($) {
  'use strict';

  function StandardizeAdres(element) {
    this.container = element;
    this.controls = {
      postcode: this.getElement('postcode'),
      huisnummer: this.getElement('huisnummer'),
      huisnummertoevoeging: this.getElement('huisnummertoevoeging'),
      straat: this.getElement('straat'),
      straathidden: this.getElement('straathidden'),
      plaats: this.getElement('plaats'),
      plaatshidden: this.getElement('plaatshidden'),

      manualAdresContainer: this.getElement('manualadrescontainer'),
      standardizedAdresContainer: this.getElement('standardizedadrescontainer'),
      manualAdresLink: this.getElement('manualadreslink'),
      loader: this.getElement('loader')
    };
    
    this.standardizedAdres = {};
    this.xhrRequest = undefined;
    this.init();
    this.bindEvents();
  }

  StandardizeAdres.prototype.init = function () {
    // Initialize method
    var formButtonSelector = this.container.attr('data-stadr-formbutton');

    if (formButtonSelector) {
      this.controls.formbutton = $(formButtonSelector);
    }

    this.errorMessage = this.container.attr('data-stadr-errormessage');
    if (!this.errorMessage || this.errorMessage == '') {
      this.errorMessage = 'Er is iets fout gegaan bij het ophalen van uw adres.';
    }
  };

  StandardizeAdres.prototype.getElement = function (elementSelector) {
    return this.container.find('[data-stadr-elem=' + elementSelector + ']');
  };

  StandardizeAdres.prototype.bindEvents = function() {
    var self = this;

    this.controls.manualAdresLink.click(function () {
      self.showCustomAdres($(this));
      return false;
    });

    this.controls.postcode.blur(function() {
      self.retrieveAdres();
    });
    this.controls.huisnummer.blur(function() {
      self.retrieveAdres();
    });
    this.controls.huisnummertoevoeging.blur(function() {
      self.retrieveAdres();
    });
  };

  StandardizeAdres.prototype.reInit = function () {
    formsHelper.reInitForms();
    this.updateMeetids();
  };

  StandardizeAdres.prototype.updateMeetids = function() {
    if (setmeetids) {
      setmeetids.init();
    }
  }

  StandardizeAdres.prototype.post = function (url, body, succesCallback, errorCallback) {
    return $.ajax({
      type: 'POST',
      url: '/sitecoreapi/spa/digest',
      data: null,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      },
      success: function (data) {
        $.ajax({
          type: 'POST',
          url: url,
          data: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            __RequestVerificationToken: data
          },
          success: succesCallback,
          dataType: 'json'
        }).fail(errorCallback);
      },
      dataType: 'json'
    }).fail(errorCallback);
  };

  StandardizeAdres.prototype.retrieveAdres = function () {
    var postcode, huisnummer, huisnummertoevoeging, self, request;

    self = this;
    postcode = self.controls.postcode;
    huisnummer = self.controls.huisnummer;
    huisnummertoevoeging = self.controls.huisnummertoevoeging;

    if (postcode.val() !== '' && this.isValidFormField(postcode) && huisnummer.val() != '' && this.isValidFormField(huisnummer) &&
      (self.standardizedAdres.postcode !== postcode.val() || self.standardizedAdres.huisnummer !== huisnummer.val() ||
        self.standardizedAdres.huisnummertoevoeging !== huisnummertoevoeging.val())) {
      // Copy data, so next call only exists for new adres
      self.standardizedAdres.postcode = postcode.val();
      self.standardizedAdres.huisnummer = huisnummer.val();
      self.standardizedAdres.huisnummertoevoeging = huisnummertoevoeging.val();

      request = {
        adres: {
          postcode: postcode.val(),
          huisnummer: huisnummer.val(),
          huisnummertoevoeging: huisnummertoevoeging.val()
        }
      };

      this.enableButton(false);
      this.enableStandizedAdres(false);
      this.showLoadingStandizedAdres(true);

      if (this.xhrRequest) {
        this.xhrRequest.abort();
      }

      this.xhrRequest = this.post(
        '/apiproxy/standaardiserenadres', request,
        function (response) {
          var streetline, cityline, adresWrapper;

          self.enableButton(true);
          self.showLoadingStandizedAdres(false);

          if (!response || !response.adres || !response.adres.straat || !response.adres.plaats) {
            // Foutsituatie
            self.errorStandardizedAdres();
              return;
          }

          self.enableStandizedAdres(true);
          self.enableManualAdres(false);

          // Clear manual adres
          self.clearCustomAders();

          // Show adres
          self.controls.straathidden.val(response.adres.straat);
          self.controls.plaatshidden.val(response.adres.plaats);

          streetline = response.adres.straat + ' ' + response.adres.huisnummer;
          if (response.adres.huisnummerToevoeging && response.adres.huisnummerToevoeging !== '') {
            streetline = streetline + ' ' + response.adres.huisnummerToevoeging;
          }
          cityline = response.adres.postcode + ' ' + response.adres.plaats;

          adresWrapper = self.controls.standardizedAdresContainer.find('.standardized-adres__standardized-adres-wrapper');
          adresWrapper.empty();

          $('<div>').addClass('ipo-hidden-field-container').append(streetline)
            .appendTo(adresWrapper);
          $('<div>').addClass('ipo-hidden-field-container').append(cityline)
            .appendTo(adresWrapper);

          // Clear possible error message
          self.controls.manualAdresContainer.find('.standardized-adres__adres-errormessage').empty();
        },
        function (xhr, status, error) {
          self.enableButton(true);
          self.showLoadingStandizedAdres(false);
          self.errorStandardizedAdres();
        });
    }
  };

  StandardizeAdres.prototype.clearCustomAders = function() {
    if (this.controls.straat.length > 0) {
      formsHelper.clearFormField(this.controls.straat[0]);
    }

    if (this.controls.plaats.length > 0) {
      formsHelper.clearFormField(this.controls.plaats[0]);
    }
  }

  StandardizeAdres.prototype.isValidFormField = function(field) {
    if (field.length <= 0) {
      return false;
    }

    var mdcField = window.form.getFormField(field[0])
    return mdcField.valid;
  }

  StandardizeAdres.prototype.enableStandizedAdres = function (isEnabled) {
    if (isEnabled) {
      this.enableFields(this.controls.straathidden, this.controls.plaatshidden);
      this.controls.standardizedAdresContainer.removeClass('standardized-adres__standardized-adres-container--hidden');
    } else {
      this.disableFields(this.controls.straathidden, this.controls.straathidden);
      this.controls.standardizedAdresContainer.addClass('standardized-adres__standardized-adres-container--hidden');
    }
  };

  StandardizeAdres.prototype.showLoadingStandizedAdres = function (show) {
    if (show) {
      this.controls.loader.removeClass('standardized-adres__loader--hidden');
    }
    else {
      this.controls.loader.addClass('standardized-adres__loader--hidden');
    }
  };

  StandardizeAdres.prototype.errorStandardizedAdres = function () {
    // Show error
    this.controls.manualAdresContainer.find('.standardized-adres__adres-errormessage').empty()
      .append(this.errorMessage);

    // Enable input fields
    this.enableManualAdres(true);

    // Clear/disable standardized adres
    this.enableStandizedAdres(false);
    this.controls.straathidden.val('');
    this.controls.plaatshidden.val('');

    // Reinitialize parsley
    this.reInit();

    // Clear retrievedAdresData
    this.standardizedAdres.postcode = '';
    this.standardizedAdres.huisnummer = '';
    this.standardizedAdres.huisnummertoevoeging = '';
  };

  StandardizeAdres.prototype.showCustomAdres = function () {
    this.enableManualAdres(true);

    this.disableFields(this.controls.straathidden, this.controls.plaatshidden);
    this.controls.standardizedAdresContainer.addClass('standardized-adres__standardized-adres-container--hidden');
    this.reInit();
    return false;
  };

  StandardizeAdres.prototype.enableManualAdres = function (isEnabled) {
    if (isEnabled) {
      this.enableFields(this.controls.straat, this.controls.plaats);
      this.controls.manualAdresContainer.removeClass('standardized-adres__manual-adres-container--hidden');
    } else {
      this.disableFields(this.controls.straat, this.controls.plaats);
      this.controls.manualAdresContainer.addClass('standardized-adres__manual-adres-container--hidden');
    }
  };

  StandardizeAdres.prototype.enableButton = function (isEnabled) {
    if (this.controls.formbutton) {
      if (isEnabled)
      {
        this.controls.formbutton.removeClass('button--disabled');
        this.controls.formbutton.prop('disabled', false);
      }
      else {
        this.controls.formbutton.addClass('button--disabled');
        this.controls.formbutton.prop('disabled', true);
      }
      
    }
  };

  StandardizeAdres.prototype.enableFields = function () {
    var i;

    if (!arguments) {
      return;
    }
    for (i = 0; i < arguments.length; i++) {
      this.enableField(arguments[i]);
    }
  };

  StandardizeAdres.prototype.enableField = function (field) {
    field.prop('disabled', false);
    field.closest('.mdc-text-field').removeClass('mdc-text-field--disabled');
  };

  StandardizeAdres.prototype.disableFields = function () {
    var i;

    if (!arguments) {
      return;
    }
    for (i = 0; i < arguments.length; i++) {
      this.disableField(arguments[i]);
    }
  };

  StandardizeAdres.prototype.disableField = function (field) {
    field.prop('disabled', true);
    field.closest('.mdc-text-field').addClass('mdc-text-field--disabled');
  };

  $(document).ready(function () {
    var adresElements = $('.standardized-adres');
    if (adresElements.length > 0) 
    {
      adresElements.each(function() {
        new StandardizeAdres($(this));
      });      
    }
  });
});
